import { ConfigType } from "../../abstract/Form";

export const config: ConfigType = {
  right: [
    {
      label: "form.patientBackground",
      rows: [
        {
          fields: [
            {
              name: "patient",
              label: "form.fields.patient",
              type: "text",
              required: true,
            },
          ],
        },
        {
          fields: [
            {
              name: "birth",
              label: "form.fields.birth",
              type: "month",
              required: true,
            },
          ],
        },
      ],
    },
    {
      label: "form.cycleDetails",
      rows: [
        {
          fields: [
            {
              name: "transfer",
              label: "form.fields.transfer",
              type: "date",
              required: false,
            },
          ],
        },
        {
          fields: [
            {
              name: "fertilization",
              label: "form.fields.fertilization",
              type: "button-selection",
              options: [
                { label: "IVF", value: "0" },
                { label: "ICSI", value: "1" },
              ],
              required: false,
            },
          ],
        },
      ],
    },
  ],
  left: [],
};
